import React from 'react'
import PropTypes from 'prop-types'
import { styled } from 'next-yak'

import { tc, t } from '@ulule/localize'
import { NotificationModal, PrimaryLink, Pastille, Title2, RegularText, CallToAction } from '@ulule/owl-kit-components'

import { mainUrlsShape } from '$utils/prop-types'
import { addQueryParamsToUrl } from '$utils/misc'

const StyledCallToAction = styled(CallToAction)`
  // yak does not give a class to non exported styled-component with no css.
  // this is an issue because this component is used as a selector later in the file
  // to fix this we need to add a bogus css rule to force yak to generate a class
  // see : https://github.com/DigitecGalaxus/next-yak/issues/373
  --bogus-style: 0;
`
const StyledPastille = styled(Pastille)`
  // yak does not give a class to non exported styled-component with no css.
  // this is an issue because this component is used as a selector later in the file
  // to fix this we need to add a bogus css rule to force yak to generate a class
  // see : https://github.com/DigitecGalaxus/next-yak/issues/373
  --bogus-style: 0;
`

const ModalContent = styled.div`
  text-align: center;

  ${StyledPastille} {
    margin: auto;
    transform: translateY(-90px);
    margin-bottom: -90px;
  }

  ${StyledCallToAction} {
    margin-top: 30px;
  }

  ${Title2} {
    margin-bottom: 10px;
    margin-top: 10px;
  }
`

export const ModalProjectRemindMe = ({ isOpen, modalImg, onClose }) => (
  <NotificationModal isClosable overlay isOpen={isOpen} onClosing={onClose}>
    <ModalContent>
      <StyledPastille>
        <img
          src={modalImg && modalImg.x1}
          srcSet={`${modalImg && modalImg.x2} 2x, ${modalImg && modalImg.x3} 3x`}
          alt=""
        />
      </StyledPastille>
      <Title2 align="center">{t('Project listed')}</Title2>
      <RegularText>{t('You will be notified by email 48 hours before project ends.')}</RegularText>
      <StyledCallToAction onClick={onClose}>{t('Ok, thanks')}</StyledCallToAction>
    </ModalContent>
  </NotificationModal>
)

ModalProjectRemindMe.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  modalImg: PropTypes.shape({
    '1x': PropTypes.string,
    '2x': PropTypes.string,
    '3x': PropTypes.string,
  }),
}

const addNextUrl = (url) => {
  const params = { next: window.location.href }
  return addQueryParamsToUrl(url, params)
}

export const ModalProjectNoAuth = ({ isOpen, urls, modalImg, onClose }) => (
  <NotificationModal isClosable overlay isOpen={isOpen} onClosing={onClose}>
    <ModalContent>
      <StyledPastille>
        <img
          src={modalImg && modalImg.x1}
          srcSet={`${modalImg && modalImg.x2} 2x, ${modalImg && modalImg.x3} 3x`}
          alt=""
        />
      </StyledPastille>
      <Title2 align="center">{t('Add to my list')}</Title2>
      <RegularText>
        {tc(
          "[login: Login] to your Ulule account to like this project.[br] You don't have an account yet ? [br][signup: Signup].",
          {
            login: <PrimaryLink href={urls && addNextUrl(urls.signin)} />,
            signup: <PrimaryLink href={urls && addNextUrl(urls.join)} />,
            br: <br />,
          },
        )}
      </RegularText>
    </ModalContent>
  </NotificationModal>
)

ModalProjectNoAuth.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  urls: mainUrlsShape,
  isAuthenticated: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  modalImg: PropTypes.shape({
    '1x': PropTypes.string,
    '2x': PropTypes.string,
    '3x': PropTypes.string,
  }),
}
